import {
  getMessaging,
  registerDeviceForRemoteMessages,
  subscribeToTopic,
  onNotificationOpenedApp,
  getInitialNotification,
} from '@react-native-firebase/messaging';
import {getAnalytics, setUserId, logEvent} from '@react-native-firebase/analytics';
import {requestNotifications, RESULTS} from 'react-native-permissions';

type NotificationHandler = (url: string) => void;

export async function addInAppTrigger(name: string, value: string) {
  const eventName = `${name}_${value}`.slice(0, 40);
  try {
    const analytics = getAnalytics();
    await logEvent(analytics, eventName);
  } catch (error) {
    console.error('[Analytics] Error logging event:', error);
  }
}

export async function initializePushPermissions(topic = 'geral') {
  const {status} = await requestNotifications(['alert', 'badge', 'sound']);
  const enabled = status === RESULTS.GRANTED || status === RESULTS.LIMITED;

  if (enabled) {
    const messaging = getMessaging();
    await registerDeviceForRemoteMessages(messaging);
    await subscribeToTopic(messaging, topic);
    return true;
  }

  return false;
}

export function bindNotificationOpen(handler: NotificationHandler) {
  const messaging = getMessaging();
  const unsubscribe = onNotificationOpenedApp(messaging, remoteMessage => {
    const url = remoteMessage?.data?.url as string;
      console.log(remoteMessage?.data);
    if (url) {

      handler(url);
    }
  });

  getInitialNotification(messaging)
    .then(remoteMessage => {
      const url = remoteMessage?.data?.url as string;
        console.log(remoteMessage?.data);
      if (url) {
        handler(url);
      }
    })
    .catch(error => {
      console.error('[FIREBASE]: Erro ao obter notificação inicial:', error);
    });

  return unsubscribe;
}



export function identifyUserForPush(userId: string | null) {
  const analytics = getAnalytics();
  setUserId(analytics, userId || null);
}
